import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $failFormTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('sorry'),
  textButton: t('sign_in'),
  unknownErr: t('unknown_error'),
}))
